// extracted by mini-css-extract-plugin
export default {"outlet":"errors_outlet__aGMO3","title":"errors_title__vzP3s","errors":"errors_errors__XK0mz","markAsSolved":"errors_markAsSolved__25g1l"};